import router from "./router"
// import store from './store'
// 路由拦截
router.beforeEach((to, from, next) => {
  // to.matched 是一个数组（匹配到是路由记录）
  // console.log(store)
  // if (!store.state.authorization) {
  //   // 跳转到登录页面
  //   next({
  //     name: 'login',
  //     query: {
  //       redirect: to.path
  //     }
  //   })
  // } else {
  //   next() // 允许通过
  // }
  next()
  // // 路由守卫中一定要调用 next，否则页码无法展示
})